import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const RoomDevicesComponent = lazy(() => import('./room-devices.tsx'));

export const roomDevicesRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <RoomDevicesComponent />
      </Suspense>
    )
  }
];
